export const RecordingStatus = {
    RECORDING: 'RECORDING',
    PAUSED: 'PAUSED',
    NONE: 'NONE',
};
